var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[(_vm.loading)?_c('loading',{attrs:{"active":_vm.loading}},[_vm._t("default")],2):[_vm._t("default")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }